$(function(){

    $('#modal-sorted .step-border').click(function(){
        $('.step-border.checked').removeClass('checked');
        $(this).toggleClass('checked');
    });

    var $modalSorted = $('#modal-sorted');
    $modalSorted.on('shown.bs.modal', function (e) {
        $('body').attr('style','overflow: hidden');
    });

    $modalSorted.on('hidden.bs.modal', function (e) {
        $('body').attr('style','overflow: inherit');
    });

    $('#asc').on( 'click', function(e) {
        var $changeOrder = $('#change-order i');
        $changeOrder.addClass('icon-filter-down');
        $changeOrder.removeClass('icon-filter-up');
    });
    $('#desc').on( 'click', function(e) {
        var $changeOrder = $('#change-order i');
        $changeOrder.addClass('icon-filter-up');
        $changeOrder.removeClass('icon-filter-down');
    });
    
});